import React from 'react'
import {
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from 'reactstrap'
import FormCard from '../common/FormCard'

const statusOptions = [
  { value: 'ACTIVE', label: 'Activo' },
  { value: 'BLOCKED', label: 'Bloqueado' },
  { value: 'DELETED', label: 'Eliminado' },
]

function AddInstanceForm({
  formData,
  errors,
  submitted,
  isSaving,

  distributors,
  isLoadingDistributors,
  onChange,
  onSubmit,
  onCancel,
}) {
  const safeDistributors = Array.isArray(distributors) ? distributors : []

  return (
    <FormCard
      title="Formulario de Instancia"
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitLabel="Guardar Instancia"
      showCancel
      isSubmitting={isSaving}
    >
      <FormGroup>
        <Label for="name">
          Nombre <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="name"
          id="name"
          placeholder="Ingrese el nombre de la instancia"
          value={formData.name}
          onChange={onChange}
          invalid={!!errors.name}
        />
        {errors.name && (
          <FormFeedback>{errors.name}</FormFeedback>
        )}
      </FormGroup>

      <FormGroup>
        <Label for="fiscalName">
          Nombre fiscal <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="fiscalName"
          id="fiscalName"
          placeholder="Ingrese el nombre fiscal"
          value={formData.fiscalName}
          onChange={onChange}
          invalid={submitted && !!errors.fiscalName}
        />
        {submitted && errors.fiscalName && (
          <FormFeedback>{errors.fiscalName}</FormFeedback>
        )}
      </FormGroup>

      <FormGroup>
        <Label for="distributorId">
          Distribuidor <span className="text-danger">*</span>
        </Label>
        <Input
          type="select"
          name="distributorId"
          id="distributorId"
          value={formData.distributorId}
          onChange={onChange}
          invalid={submitted && !!errors.distributorId}
          disabled={isLoadingDistributors}
        >
          <option value="">Selecciona un distribuidor</option>
          {safeDistributors.map((distributor) => (
            <option key={distributor.id} value={distributor.id}>
              {distributor.name} 
            </option>
          ))}
        </Input>
        {submitted && errors.distributorId && (
          <FormFeedback>{errors.distributorId}</FormFeedback>
        )}
      </FormGroup>
    </FormCard>
  )
}

export default AddInstanceForm
